import Service from '@ember/service';
import { jsonGet, jsonPost } from '@square/dashboard-utilities/utils/xhr';
import DeviceProfileModel from '@square/dashboard-data/models/device-profile';
function buildDeviceProfileURL(deviceCredential) {
  const primaryKeyValue = deviceCredential.token;
  return `${deviceCredential.constructor.url}/${primaryKeyValue}/profile`;
}
export function fetchDeviceProfile(deviceCredential) {
  const url = buildDeviceProfileURL(deviceCredential);
  return jsonGet(url).then(data => {
    return DeviceProfileModel.deserialize(data.device_profile);
  });
}
const DEVICE_PROFILE_URL = '/api/v1/device-profiles';
export default class DeviceProfile extends Service {
  getDeviceProfiles() {
    return jsonGet(DEVICE_PROFILE_URL).then(data => {
      if (data.device_profiles) {
        return data.device_profiles.map(profile => DeviceProfileModel.deserialize(profile));
      }
      return [];
    });
  }
  createSharedDeviceProfile(deviceProfileName, deviceProfileSettings) {
    return jsonPost(DEVICE_PROFILE_URL, {
      device_profile: {
        name: deviceProfileName,
        shared: true,
        settings: deviceProfileSettings.toJSON()
      }
    }).then(data => {
      return DeviceProfileModel.deserialize(data.device_profile);
    });
  }
  updateDeviceProfile(deviceProfile) {
    return jsonPost(`${DEVICE_PROFILE_URL}/${deviceProfile.get('token')}`, {
      device_profile: deviceProfile.toJSON()
    }).then(data => {
      return DeviceProfileModel.deserialize(data.device_profile);
    });
  }
  deleteDeviceProfile(deviceProfile) {
    return jsonPost(`${DEVICE_PROFILE_URL}/${deviceProfile.get('token')}/delete`);
  }
}